<template>
	<div class="page">
		<top />
		<div style="width: 100%;height: 55px;"></div>
		<div class="off">
			<div class="offline">
				<div class="question">{{ type == 'copyrightissues'?'版权问题':'售后问题' }}</div>
			</div>
			<div class="offlin2"  v-html="content"></div>
		</div>
			<info />
			<div style="width: 100%;height: 60px;background-color: #F6F6F6;"></div>
			<foot />
		</div>
</template>

<script>
	import top from "../../components/common/header.vue";
	import foot from "../../components/common/footer.vue";
	import info from "../../components/common/qrCode.vue";
	import { clauseData } from "../../request/api";
	export default {
		components: {
			top,
			foot,
			info
		},
		data() {
			return {
				content: "",
				type: "",
			};
		},
		created() {
			this.type = this.$route.query.type
			document.title = '以图绘图印花设计网-' + this.type == 'copyrightissues'?'版权问题':'售后问题';
			this.getClauseData();
		},
		methods: {
			getClauseData() {
			  clauseData({
			    type: this.type,
			  }).then((res) => {
			    // console.log(res.data);
			    this.content = this.showHtml(res.data);
			  });
			},
			
			showHtml(str) {
			  return str
			    .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
			    .replace(/&lt;/g, "<")
			    .replace(/&gt;/g, ">")
			    .replace(/&quot;/g, '"')
			    .replace(/&#39;/g, "'")
			    .replace(/&amp;nbsp;/g, "\u3000");
			},
		},
	};
</script>

<style lang="less" scoped>
	.page {
		background: #F6F6F6;

		.home {
			padding: 0 20px;
			display: flex;
			align-items: center;
			font-size: 13px;

			div {
				margin-right: 7px;
			}
		}
		.off {
			margin-top: 15px;
			padding: 0 10px;
			margin-bottom: 180px;
			.offline {
				padding: 0 12px 12px 12px;
				font-size: 12px;
				background-color: #FFFFFF;
				color: #08243C;
				display: flex;
				.question {
					width: 100%;
					font-size: 14px;
					text-align: center;
					padding: 18px 0;
					border-bottom: 1px #DADEE2 solid;
				}
				
			}
			.offlin2 {
				background-color: #FFFFFF;
				font-size: 12px;
				color: #333333;
				padding: 8px 18px 17px 18px;
				line-height: 25px;
			}
		}
		
	}
</style>
